import React, { Component } from 'react'
import axios from 'axios'
import lruCache from 'lru-cache'
import { ExternalLink } from 'react-feather'
import ReactHtmlParser from 'react-html-parser'
import moment from 'moment'

import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

import twitterConfig from './TwitterConfig'

const wikipediaCache = new lruCache({
    max: 50,
    maxAge: 1000 * 60 * 60 * 24,
})

class Wikipedia extends Component {
    constructor(props) {
        super(props)

        this.state = {
            text: null,
            retrievedAt: 0,
            link: null,
        }

        this.download = this.download.bind(this)
    }

    componentDidMount() {
        this.download(this.props.pageId, (err, page) => {
            if (page) {
                this.setState(Object.assign({}, this.state, {
                    text: page.text,
                    retrievedAt: page.retrievedAt,
                    link: page.link,
                    elements: ReactHtmlParser(page.text),
                }))
            }
        })
    }

    download(pageId, callback) {
        if (wikipediaCache.has(pageId)) {
            callback(null, wikipediaCache.get(pageId))
            return
        }

        axios
        .get('/server/wikipedia.js', {
            params: {
                pageId: pageId
            }
        })
        .then(response => {
            const page = {
                text: response.data,
                retrievedAt: parseInt(response.headers['X-'+twitterConfig.alias+'-Wikipedia-Retrieved-At'.toLowerCase()], 10),
                link: response.headers['X-'+twitterConfig.alias+'-Wikipedia-Retrieved-From'.toLowerCase()] || ("https://en.wikipedia.org/wiki/" + this.props.pageId),
            }
            wikipediaCache.set(pageId, page)
            callback(null, page)
        })
        .catch(error => {
            callback(error)
        })
        .then(() => { })
    }

    render() {
        let citation = ''
        if (this.state.retrievedAt > 100) {
            citation = (
                <p className="citation text-xs text-muted-foreground mt-2">
                    - { this.props.title }. (n.d.). In <i>Wikipedia</i>. Retrieved { moment(this.state.retrievedAt).format('MMMM D, Y') }, from <a href={ this.state.link }>{ this.state.link }</a>
                </p>
            )
        }

        return (
            <Card className="mb-2">
                <CardContent className="p-4">
                    <div className="flex items-start justify-between mb-2">
                        <h6 className="font-semibold text-sm mb-0">
                            { this.props.title || this.props.pageId }
                        </h6>
                        <Button variant="ghost" size="icon-sm" asChild className="shrink-0 ml-2">
                            <a href={ this.state.link } target="_blank" rel="noopener noreferrer">
                                <ExternalLink className="icon-sm" />
                            </a>
                        </Button>
                    </div>
                    <div className="App-explanations text-sm">
                        { this.state.elements }
                    </div>
                    { citation }
                </CardContent>
            </Card>
        )
    }
}

export default Wikipedia
